import React, { useState } from 'react';
import { Card } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';

const CollapsibleCard = ({ title, extra, children, defaultCollapsed = true, style, size = 'small', bodyStyle, ...rest }) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <Card
      size={size}
      style={style}
      styles={{
        body: {
          ...(collapsed
            ? { padding: 0, overflow: 'hidden', maxHeight: 0 }
            : bodyStyle),
        },
      }}
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed(c => !c)}
        >
          {collapsed
            ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} />
            : <DownOutlined  style={{ fontSize: 11, color: '#9ca3af' }} />
          }
          {title}
        </span>
      }
      extra={extra}
      {...rest}
    >
      {children}
    </Card>
  );
};

export default CollapsibleCard;
